var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basket",class:{ 'd-none': !_vm.apartmentCount }},[_c('p',[_vm._v("Убранные квартиры: "+_vm._s(_vm.apartmentCount))]),_c('base-button',{attrs:{"design":"violet500","text":"Вернуть все квартиры"},on:{"click":_vm.returnApartment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }